import { PiiCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function PiiFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <PiiCommandList multiselect selected={selection} onSelect={onSelect} />
}
